import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { FC } from "react";

import { BulkAction, CONFIRM_COPY } from "./campaignBulkActions";

type BulkActionConfirmModalProps = {
  action: BulkAction;
  count: number;
  isApplying: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const BulkActionConfirmModal: FC<BulkActionConfirmModalProps> = ({ action, count, isApplying, onConfirm, onClose }) => {
  const copy = CONFIRM_COPY[action];

  return (
    <Dialog open onClose={onClose} aria-labelledby="bulk-action-dialog-title" fullWidth maxWidth="sm">
      <DialogTitle id="bulk-action-dialog-title">{copy.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{copy.body(count)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={isApplying}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" disabled={isApplying}>
          {isApplying ? "Working…" : copy.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkActionConfirmModal;
